import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { defineMessages, FormattedDate, useIntl } from "react-intl";
import moment from "moment";
import { STATUSES } from "../../globals/workOrderStatus";
import RequestDueDate from "../requestDueDate/requestDueDate";
import CalendarIcon from "../common/icons/calendarIcon";

const messages = defineMessages({
    calendarIconTitle: {
        id: "date-RDD-field.calendar-icon-title",
        defaultMessage: "Request New Due Date",
        description: "clickable option to request new due date",
    },
});

const DueDateRenderer = (props) => {
    const intl = useIntl();
    const { params } = props;
    const [showRDDModal, setShowRDDModal] = useState(false);
    const task = params?.id;
    const value = params?.value;
    const status = params?.row?.["statusId"];

    if (!params || !params.row) {
        return null;
    }

    const formateDate = (iDate) => (iDate ? moment.utc(iDate).add(moment().utcOffset(), "minutes").format("MMM D, YYYY") : "");

    return process.env.REACT_APP_FEATURE_RAPREQUEST === "true" && status === STATUSES.UNASSIGNED ? (
        <React.Fragment>
            <div className="task-item-field due-date" role="duedatefield" onMouseDown={() => setShowRDDModal(true)}>
                {value ? (
                    formateDate(value)
                ) : (
                    <FormattedMessage id="rdd-dialog.no-due-date" defaultMessage="No due date" description="No due date text" />
                )}
                <CalendarIcon title={intl.formatMessage(messages.calendarIconTitle)} />
            </div>
            <RequestDueDate workOrder={task} show={showRDDModal} close={() => setShowRDDModal(false)} />
        </React.Fragment>
    ) : (
        <div className="task-item-field">
            {value ? (
                formateDate(value)
            ) : (
                <FormattedMessage id="rdd-dialog.no-due-date" defaultMessage="No due date" description="No due date text" />
            )}
        </div>
    );
};

export default DueDateRenderer;
